import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconReport.tsx
const OutlinedFilledReport = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-264q19.38 0 32.69-13.31Q526-290.63 526-310q0-19-13.31-33T480-357q-19.37 0-32.69 14Q434-329 434-310t13.31 32.5Q460.63-264 480-264Zm-36-140h72v-298h-72v298ZM320-95 95-319.82V-641l224.82-225H641l225 224.82V-320L641.18-95H320Z" })
});
const OutlinedReport = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-264q19.38 0 32.69-13.31Q526-290.63 526-310q0-19-13.31-33T480-357q-19.37 0-32.69 14Q434-329 434-310t13.31 32.5Q460.63-264 480-264Zm-36-140h72v-298h-72v298ZM320-95 95-319.82V-641l224.82-225H641l225 224.82V-320L641.18-95H320Zm38.62-94H601l170-169.62V-601L601.38-771H359L189-601.38V-359l169.62 170ZM480-480Z" })
});
const RoundedFilledReport = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-264q19.38 0 32.69-13.31Q526-290.63 526-310q0-19-13.31-33T480-357q-19.37 0-32.69 14Q434-329 434-310t13.31 32.5Q460.63-264 480-264Zm0-140q16.4 0 26.2-9.8T516-440v-225.63q0-15.41-9.8-25.89T480-702q-16.4 0-26.2 10.27t-9.8 25.89v225.45q0 15.39 9.8 25.89T480-404ZM359-95q-18.96 0-36.77-7.46-17.8-7.45-31.23-20.54L123-291q-13.09-13.43-20.54-31.23Q95-340.04 95-359v-242q0-18.96 7.46-36.77 7.45-17.8 20.54-31.23l168-168q13-13 30.94-21 17.95-8 37.06-8h242q19.11 0 37.06 8Q656-850 669-837l168 168q13 13 21 30.94 8 17.95 8 37.06v242q0 19.11-8 37.06Q850-304 837-291L669-123q-13.43 13.09-31.23 20.54Q619.96-95 601-95H359Z" })
});
const RoundedReport = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-264q19.38 0 32.69-13.31Q526-290.63 526-310q0-19-13.31-33T480-357q-19.37 0-32.69 14Q434-329 434-310t13.31 32.5Q460.63-264 480-264Zm0-140q16.4 0 26.2-9.8T516-440v-225.63q0-15.41-9.8-25.89T480-702q-16.4 0-26.2 10.27t-9.8 25.89v225.45q0 15.39 9.8 25.89T480-404ZM359-95q-18.96 0-36.77-7.46-17.8-7.45-31.23-20.54L123-291q-13.09-13.43-20.54-31.23Q95-340.04 95-359v-242q0-18.96 7.46-36.77 7.45-17.8 20.54-31.23l168-168q13-13 30.94-21 17.95-8 37.06-8h242q19.11 0 37.06 8Q656-850 669-837l168 168q13 13 21 30.94 8 17.95 8 37.06v242q0 19.11-8 37.06Q850-304 837-291L669-123q-13.43 13.09-31.23 20.54Q619.96-95 601-95H359Zm-.38-94H601l170-169.62V-601L601.38-771H359L189-601.38V-359l169.62 170ZM480-480Z" })
});
const SharpFilledReport = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-264q19.38 0 32.69-13.31Q526-290.63 526-310q0-19-13.31-33T480-357q-19.37 0-32.69 14Q434-329 434-310t13.31 32.5Q460.63-264 480-264Zm-36-140h72v-298h-72v298ZM320-95 95-319.82V-641l224.82-225H641l225 224.82V-320L641.18-95H320Z" })
});
const SharpReport = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-264q19.38 0 32.69-13.31Q526-290.63 526-310q0-19-13.31-33T480-357q-19.37 0-32.69 14Q434-329 434-310t13.31 32.5Q460.63-264 480-264Zm-36-140h72v-298h-72v298ZM320-95 95-319.82V-641l224.82-225H641l225 224.82V-320L641.18-95H320Zm38.62-94H601l170-169.62V-601L601.38-771H359L189-601.38V-359l169.62 170ZM480-480Z" })
});
const componentMap = {
	outlined: OutlinedReport,
	"outlined-fill": OutlinedFilledReport,
	rounded: RoundedReport,
	"rounded-fill": RoundedFilledReport,
	sharp: SharpReport,
	"sharp-fill": SharpFilledReport
};
const IconReport = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconReport };